// extracted by mini-css-extract-plugin
export default {"whitelabel":"Whitelabel_whitelabel__N13n3","hover":"Whitelabel_hover__Pdyaz","decor":"Whitelabel_decor__tb+0t","image":"Whitelabel_image__61iC-"};